<script>
import { Bubble, mixins } from 'vue-chartjs';

export default {
    name: 'BubbleChart',
    extends: Bubble,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                },
                animation: false,
            }
        }
    },
    mounted () {
        if (this.$el.offsetWidth || typeof ResizeObserver === 'undefined') {
            this.renderChart(this.chartData, this.options);
            return;
        }

        // Modals mount their content while still hidden. Chart.js sizes the canvas to
        // nothing and its own resize detection can't arm itself, so wait for a real size.
        this.sizeObserver = new ResizeObserver(() => {
            if (!this.$el.offsetWidth) return;

            this.stopObservingSize();
            this.renderChart(this.chartData, this.options);
        });
        this.sizeObserver.observe(this.$el);
    },
    beforeDestroy () {
        this.stopObservingSize();
    },
    methods: {
        stopObservingSize () {
            if (!this.sizeObserver) return;

            this.sizeObserver.disconnect();
            this.sizeObserver = null;
        }
    }
};
</script>
